import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import '../ComboBox/v1/DSComboBox.js';
import { DSComboBox2 } from '../ComboBox/v2/Combobox.js';
import { MultiValueLabel } from './components/MultiValueLabel.js';
import { MultiValueRemove } from './components/MultiValueRemove.js';
import { SingleValue } from './components/SingleValue.js';
import { SingleValueRemove } from './components/SingleValueRemove.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import 'react-select';
import 'react-popper';
import 'react-measure';
import '@elliemae/ds-utilities/utils';
import '../ComboBox/v1/withSelectStringValueConverter.js';
import '@babel/runtime/helpers/esm/typeof';
import '../prop-types-cc01d273.js';
import '../ComboBox/v1/components/Control.js';
import '../ComboBox/v1/components/DropdownIndicator.js';
import '@elliemae/ds-icons/ChevronSmallDown';
import '@elliemae/ds-button';
import '../ComboBox/v1/components/SelectMenu.js';
import '@elliemae/ds-overlay';
import '@elliemae/ds-menu';
import '@elliemae/ds-popper';
import '../ComboBox/v1/components/ClearIndicator.js';
import '@elliemae/ds-icons/CloseCircle';
import '../ComboBox/v1/components/MenuList.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'react-window';
import 'memoize-one';
import '../ComboBox/v1/components/CustomOption.js';
import '@elliemae/ds-truncated-tooltip-text';
import '../ComboBox/v1/components/CustomOptionMulti.js';
import '../Checkbox/DSCheckbox.js';
import 'react-desc';
import '@elliemae/ds-classnames';
import '../Checkbox/elements/CheckMark.js';
import 'styled-components';
import '../Checkbox/defaultProps.js';
import '../Checkbox/props.js';
import '../ComboBox/v1/components/MultiSelectHeader.js';
import '../ComboBox/v1/components/MultiValueLabel.js';
import '../ComboBox/v1/components/MultiValueRemove.js';
import '../ComboBox/v1/components/SingleValueLabel.js';
import '../ComboBox/v1/components/calculateWidth.js';
import '../ComboBox/v1/components/ValueContainer.js';
import 'react-select/creatable';
import '@elliemae/ds-system';
import '@elliemae/ds-utilities/hooks/usePrevious';
import '@elliemae/ds-utilities/hooks/useShouldRecalculate';
import '../ComboBox/v2/components/DropdownIndicator.js';
import '../ComboBox/v2/context.js';
import '../ComboBox/v2/components/GroupHeading.js';
import '@elliemae/ds-separator';
import '../ComboBox/v2/components/utils.js';
import '../ComboBox/v2/components/SelectMenu.js';
import '../ComboBox/v2/components/Content.js';
import '../ComboBox/v2/components/Control.js';
import '../ComboBox/v2/components/ClearIndicator.js';
import '@elliemae/ds-icons/CloseXsmall';
import '../ComboBox/v2/components/MenuList.js';
import '../ComboBox/v2/components/CustomOption.js';
import '../ComboBox/v2/components/CustomOptionMulti.js';
import '../ComboBox/v2/components/MultiSelectHeader.js';
import '../ComboBox/v2/components/useMenuListHeight.js';
import '../ComboBox/v2/components/MultiValueLabel.js';
import '../ComboBox/v2/components/MultiValueRemove.js';
import '../ComboBox/v2/components/SingleValueLabel.js';
import '../ComboBox/v2/components/LoadingIndicator.js';
import '@elliemae/ds-circular-progress-indicator';
import '../ComboBox/v2/components/calculateWidth.js';
import '../ComboBox/v2/components/ValueContainer.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var customStyles = {
  multiValueRemove: MultiValueRemove.style,
  clearIndicator: SingleValueRemove.style,
  multiValue: function multiValue(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderRadius: '10px',
      backgroundColor: '#ebf6ff'
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      display: '-webkit-box',
      flexWrap: 'nowrap',
      overflowX: 'scroll',
      overflowY: 'hidden',
      '-ms-overflow-style': 'none',
      // IE and Edge
      'scrollbar-width': 'none',
      // Firefox
      '::-webkit-scrollbar': {
        display: 'none'
      } // Chrome

    });
  }
};

function ComboBoxFreeSolo(_ref) {
  var _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onChangeV = _ref.onChangeV2,
      onChangeV2 = _ref$onChangeV === void 0 ? noop : _ref$onChangeV,
      _ref$onInputChange = _ref.onInputChange,
      onInputChange = _ref$onInputChange === void 0 ? noop : _ref$onInputChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$menuIsOpen = _ref.menuIsOpen,
      menuIsOpen = _ref$menuIsOpen === void 0 ? false : _ref$menuIsOpen,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Select values' : _ref$placeholder,
      _ref$formatCreateLabe = _ref.formatCreateLabel,
      formatCreateLabel = _ref$formatCreateLabe === void 0 ? function (val) {
    return "Create ".concat(val);
  } : _ref$formatCreateLabe,
      _ref$maxOptions = _ref.maxOptions,
      maxOptions = _ref$maxOptions === void 0 ? undefined : _ref$maxOptions;
  return /*#__PURE__*/React.createElement(DSComboBox2, {
    isFreeSolo: true,
    clearable: true,
    isMulti: isMulti,
    value: value,
    options: options,
    keepTypedValue: false,
    placeholder: placeholder,
    disabled: disabled,
    menuIsOpen: menuIsOpen,
    formatCreateLabel: formatCreateLabel,
    createOptionPosition: "first",
    onChange: onChange,
    onChangeV2: onChangeV2,
    onInputChange: onInputChange,
    onFocus: onFocus,
    onBlur: onBlur,
    containerProps: containerProps,
    maxOptions: maxOptions,
    components: {
      MultiValueLabel: MultiValueLabel,
      MultiValueRemove: MultiValueRemove,
      SingleValue: SingleValue
    },
    componentsStyle: customStyles
  });
}

ComboBoxFreeSolo.propTypes = {
  containerProps: PropTypes.object,

  /**
   * Allows a function that is triggered once the combo box is focused
   */
  onFocus: PropTypes.func,

  /**
   * Allows a function that is triggered once the combo box loses focus
   */
  onBlur: PropTypes.func,

  /**
   * Allows a function that is triggered when a new value is selected from the dropdown menu
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Allows a function that is triggered when a new value is selected from the dropdown menu
   * It will return the current options selected
   */
  onChangeV2: PropTypes.func,

  /**
   * Allows a function that is triggered once the input value changes (on every keystroke)
   */
  onInputChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),

  /**
   * Value that the combo box has as default
   */
  options: PropTypes.arrayOf(PropTypes.object),

  /**
   * Whether the combo box is disabled or not
   */
  disabled: PropTypes.bool,

  /**
   * Whether the combo box free solo is multi selectable or not
   */
  isMulti: PropTypes.bool,

  /**
   * Placeholder for the combo box
   */
  placeholder: PropTypes.string,

  /**
   * Whether the combo box menu is open or not
   */
  menuIsOpen: PropTypes.bool,

  /**
   * Whether to show the combo box menu inline or not
   */

  /**
   * function that reciveves the new value and returns the formatted value
   */
  formatCreateLabel: PropTypes.func,

  /**
   * Max options to be displayed on the menu list
   */
  maxOptions: PropTypes.number
};

export default ComboBoxFreeSolo;
//# sourceMappingURL=ComboBoxFreeSolo.js.map
